import { render, staticRenderFns } from "./continuationPreservationNew.vue?vue&type=template&id=4b719467&scoped=true&"
import script from "./continuationPreservationNew.vue?vue&type=script&lang=js&"
export * from "./continuationPreservationNew.vue?vue&type=script&lang=js&"
import style0 from "./continuationPreservationNew.vue?vue&type=style&index=0&id=4b719467&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b719467",
  null
  
)

export default component.exports